/**
 * Centralized z-index scale for the application
 * Each layer is 10 units apart to allow for micro-adjustments
 */
export const Z_INDEX = {
  // Desktop navigation layers
  TIMELINE_ICON: 2, // Event card icons above timeline connector line
  LEFT_NAV: 5, // Left navigation bar (behind content)
  SLIDE_OUT_PANEL: 8, // Slide-out menu panel (above left nav, behind content)
  NAV: 10, // Top header nav
  TABLE_STICKY: 20,
  MODAL_BASE: 50,
  MODAL_NESTED: 60,
  MODAL_NESTED_2: 70,
  DIALOG_CONFIRM: 75, // Dialog confirm modals
  DROPDOWN: 80,
  TOOLTIP: 100,
  NOTIFICATION: 200, // Notification panels / banners

  // Mobile-specific layers (higher values for full-screen mobile experiences)
  MOBILE_SEARCH_BASE: 900,
  MOBILE_SEARCH_PANEL: 910, // Filter/sort panels above search
  MOBILE_FOOTER: 1000, // Footer navigation above overlays
  MOBILE_NAV_MENU: 1000, // Hamburger menu
  MOBILE_FULLSCREEN_MODAL: 1050, // Full-screen mobile modal (covers top + footer nav)
  MOBILE_DROPDOWN: 1100, // Dropdowns within mobile UI

  // Toasts sit above everything — including full-screen mobile modals — so
  // error/success toasts are never hidden behind a modal.
  TOAST: 1200,
} as const

/**
 * Calculate z-index for nested modals
 * @param depth - Modal nesting depth (0 = base modal, 1 = first nested, etc)
 */
export const getModalZIndex = (depth: number = 0): number => {
  return Z_INDEX.MODAL_BASE + depth * 10
}

/**
 * Calculate z-index for dropdowns inside modals
 * Always 30 units above the current modal layer
 */
export const getDropdownZIndex = (modalDepth: number = 0): number => {
  return getModalZIndex(modalDepth) + 30
}
